export const API_URL = 'https://theprojectsdemo.com/PHP/FWS/api/';
